'use client';

import '@livekit/components-styles';

import type { ReactNode } from 'react';

import { BackgroundEffectProvider } from './context/BackgroundContextProvider';
import { DevicesAlertContextProvider } from './context/DevicesAlertDialogContext';
import { DevicesInfoContextProvider } from './context/DevicesInfoContext';

const Layout = ({ children }: { children: ReactNode }) => {
  return (
    <DevicesInfoContextProvider>
      <DevicesAlertContextProvider>
        <BackgroundEffectProvider>{children}</BackgroundEffectProvider>
      </DevicesAlertContextProvider>
    </DevicesInfoContextProvider>
  );
};

export default Layout;
